// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputFile,
} from '@vroskus/library-components';

// Helpers
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import config from '../../../config';

// Types
type $Props = $Translate & {
  item: $Model<'RegattaSponsor'> | $ModelUpsertParams<'RegattaSponsor'>;
};

const RegattaSponsorFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
        <Col>
          <AvField
            label={t('Link')}
            name={'Link'}
            required
            value={item.Link}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputFile
            fileDirUrl={`${config.CDN_URL}/images/max`}
            imageThumbDirUrl={`${config.CDN_URL}/images/min`}
            label={t('Picture')}
            labelChangeFile={t('Change file')}
            labelError={t('Error')}
            labelFile={t('File')}
            name={'Image'}
            onError={ErrorLog.exception}
            required
            uploadUrl={`${config.CDN_URL}/v1.0/upload/image`}
            value={item.Image}
          />
        </Col>
      </Row>
    </>
  );
};

export default RegattaSponsorFieldsView;
